import dashboard from './dashboard';
import account from './account';
import card from './card';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, card, account]
};

export default menuItems;
